import _ from 'underscore';
import $ from 'jquery';

import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { renderStatusPopupEditor } from '@bingads-webui-campaign/status-popup-editor';

import statusIconTemplate from './status-icon.pug';
import headerTemplate from './status-icon-header-template.pug';

export class StatusIconColumn extends CampaignuiBaseColumn {
  constructor({
    i18n,
    view,
    showExperiment,
    enableEdit,
    statusOptions = [{ name: 'Enabled', value: 'Active' }, { name: 'Paused', value: 'Paused' }],
    isCampaign = false,
    isForVNext = false,
    sortable,
    group,
    title,
    enableGridFlexLayout = false,
  }) {
    super({
      name: 'Status',
      property: _.compact([
        'Status',
        showExperiment && (isCampaign ? 'ExperimentId' : 'Campaign/ExperimentId'),
        isCampaign && 'ImportProperties',
      ]),
      title: title || 'Status',
      sortable: sortable || 'Status',
      isResizable: false,
      type: 'string',
      enableEdit,
      headerTemplate: () => headerTemplate({}),
      group,
    });

    this.i18n = i18n;
    this.view = view;
    this.statusOptions = statusOptions;
    this.isCampaign = isCampaign;
    this.isForVNext = isForVNext;
    this.enableGridFlexLayout = enableGridFlexLayout;
  }

  isExperiment(item) {
    return _.result(this.isCampaign ? item : item.Campaign, 'ExperimentId');
  }

  pickProperty(item) {
    const {
      Status,
      Id,
    } = item;

    return {
      Status,
      Id,
      isExperiment: this.isExperiment(item),
    };
  }

  template(model) {
    return statusIconTemplate(_.extend({}, model, {
      i18n: this.i18n, isForVNext: this.isForVNext, enableGridFlexLayout: this.enableGridFlexLayout,
    }));
  }

  onPrompt({
    event,
    item,
    position,
    newPosition,
  }) {
    if (item.CampaignType === 'Smart' && item.DeliveryStatus === 'CampaignInProgress') {
      return;
    }
    const statusEditor = renderStatusPopupEditor({
      position: this.isForVNext ? newPosition : position,
      i18n: this.i18n,
      currentStatus: item.Status,
      statusOptions: (() => {
        let options = this.statusOptions;

        if (this.isExperiment(item)) {
          options = _.map(options, (option) => {
            const iconClass = _.result({
              Enabled: 'experiment-active-icon',
              Paused: 'experiment-paused-icon',
            }, option.name);

            return _.defaults({ iconClass }, option);
          });
        }

        return options;
      })(),
      isForVNext: this.isForVNext,
    });

    $(event.target).attr('aria-expanded', 'true');

    statusEditor.then((status) => {
      $(event.target).attr('aria-expanded', 'false');

      if (status) {
        this.updateStatus({ status, item });
      }
    });
  }

  updateStatus() {
    throw new Error('updateStatus not implemented');
  }
}
